/**
 * Environment configuration.
 * Mirrors Flutter's EnvironmenConstants + APIConstants.
 */
export const ENV = import.meta.env.VITE_ENV ?? 'dev';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

/** v1/p/ — public endpoints (token still sent when signed in, as in Flutter) */
export const PUBLIC_API_URL = `${API_BASE_URL}v1/p`;

/** v1/ — authenticated endpoints */
export const AUTH_API_URL = `${API_BASE_URL}v1`;
